import React, { useState, useEffect } from 'react';
import {
  Box,
  ButtonWithAction,
  FormInput,
  Cluster,
  constants,
  FormSelect,
  Loading,
  util,
} from '@thecb/components';
import { OrdersIndexSearchInput } from './OrdersIndexSearchInput.styled';
import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from './OrdersIndexFiltersForm.state';
import { AmtFilterContainer, SelectContainer } from '../../components/styled';
import DatePicker from '../../components/date-picker';

let OrdersIndexFiltersForm = ({
  actions,
  fields,
  forms,
  showErrors,
  clear,
  shouldClear,
  fetchData,
  terminalOptions = [],
  locationOptions = [],
  orderStatusOptions = [],
  paymentMethodOptions = [],
  agencyOptions = [],
  userOptions = [],
  batchOptions = [],
  loading,
}) => {
  const [, handleErrors] = useState(false);

  const transformedPaymentMethodOptions = paymentMethodOptions.map(
    (option) => ({
      ...option,
      text: option.text === 'Wire Payment' ? 'Wire Transfer' : option.text,
    }),
  );

  useEffect(() => {
    fetchData({ pageIndex: 1 });
  }, [
    fields.paymentMethod.rawValue,
    fields.batch.rawValue,
    fields.status.rawValue,
    fields.user.rawValue,
    fields.terminal.rawValue,
    fields.location.rawValue,
    fields.agency.rawValue,
  ]);
  const oneOrMoreActiveFilters = Object.entries(fields).some(
    ([_, { rawValue }]) => Boolean(rawValue),
  );
  const clearFilterForm = () => {
    actions.form.clear();
  };

  const handleFiltersSubmit = util.general.generateClickHandler(
    forms.ordersIndexFiltersForm,
    () => handleErrors(true),
    () => fetchData({ pageIndex: 1 }),
  );

  return (
    <Box padding="0" as="form" onSubmit={handleFiltersSubmit}>
      {loading ? (
        <Loading />
      ) : (
        <>
          <OrdersIndexSearchInput
            actions={actions}
            fields={fields}
            searchErrors={showErrors}
            fetchData={fetchData}
            handleSubmit={handleFiltersSubmit}
            shouldClear={shouldClear}
            clear={clear}
          />
          <Box background={constants.colors.ATHENS_GREY}>
            <Cluster childGap="1rem" align="center" overflow="visible">
              <AmtFilterContainer>
                <FormInput
                  data-testid="Min Amount Test"
                  labelTextWhenNoError="Min Amount"
                  field={fields.minAmount}
                  fieldActions={actions.fields.minAmount}
                  type={'number'}
                  labelTextVariant="p"
                  errorTextVariant="p"
                />
              </AmtFilterContainer>
              <AmtFilterContainer>
                <FormInput
                  data-testid="Max Amount Test"
                  labelTextWhenNoError="Max Amount"
                  field={fields.maxAmount}
                  fieldActions={actions.fields.maxAmount}
                  type={'number'}
                  labelTextVariant="p"
                  errorTextVariant="p"
                />
              </AmtFilterContainer>
              <DatePicker
                label="Start Date (mm/dd/yyyy)"
                id="orders-index-start-date"
                field={fields.startDate}
                fieldActions={actions.fields.startDate}
              />
              <DatePicker
                label="End Date (mm/dd/yyyy)"
                id="orders-index-end-date"
                field={fields.endDate}
                fieldActions={actions.fields.endDate}
              />
            </Cluster>
            <Cluster childGap="1rem" align="center" overflow="visible">
              <SelectContainer>
                <FormSelect
                  hasTitles
                  data-testid="Status Test"
                  dropdownMaxHeight="200px"
                  labelTextWhenNoError="Status"
                  options={orderStatusOptions}
                  fieldActions={actions.fields.status}
                  showErrors={fields.errors}
                  field={fields.status}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="Payment Method Test"
                  labelTextWhenNoError="Payment method"
                  options={transformedPaymentMethodOptions}
                  fieldActions={actions.fields.paymentMethod}
                  showErrors={fields.errors}
                  field={fields.paymentMethod}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="Agency Test"
                  labelTextWhenNoError="Agency"
                  options={agencyOptions}
                  fieldActions={actions.fields.agency}
                  showErrors={fields.errors}
                  field={fields.agency}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="Location Test"
                  labelTextWhenNoError="Location"
                  options={locationOptions}
                  fieldActions={actions.fields.location}
                  showErrors={fields.errors}
                  field={fields.location}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="Terminal Test"
                  labelTextWhenNoError="Terminal"
                  options={terminalOptions}
                  fieldActions={actions.fields.terminal}
                  showErrors={fields.errors}
                  field={fields.terminal}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  dropdownMaxHeight="200px"
                  data-testid="User Test"
                  labelTextWhenNoError="User"
                  options={userOptions}
                  fieldActions={actions.fields.user}
                  showErrors={fields.errors}
                  field={fields.user}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
              <SelectContainer>
                <FormSelect
                  hasTitles
                  dropdownMaxHeight="200px"
                  data-testid="Batch Test"
                  labelTextWhenNoError="Batch"
                  options={batchOptions}
                  fieldActions={actions.fields.batch}
                  showErrors={fields.errors}
                  field={fields.batch}
                  widthFitOptions
                  labelTextVariant="p"
                  errorLabelTextVariant="p"
                />
              </SelectContainer>
            </Cluster>
            {oneOrMoreActiveFilters && (
              <ButtonWithAction
                type="reset"
                padding="0"
                margin="0"
                variant="smallGhost"
                action={clearFilterForm}
                text="Clear filters"
                data-testid="orders-clear-filters"
                textExtraStyles="font-size: 1rem;"
              />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

OrdersIndexFiltersForm.reducer = reducer;
OrdersIndexFiltersForm.mapStateToProps = mapStateToProps;
OrdersIndexFiltersForm.mapDispatchToProps = mapDispatchToProps;

export { OrdersIndexFiltersForm };
